import {useEffect, useState} from 'react';
import {useHistory} from 'react-router';

export enum SettingsTabs {
    EMAILTYPES = 'emailTypes',
    CHANGEPW = 'changePassword',
    TWOFACTOR = '2fa',
    GENERAL = 'general',
    TRUSTEDDEVICES = 'trustedDevices',
}

const useSettingsPage = () => {
    const [activeTab, setActiveTab] = useState<SettingsTabs>(
        SettingsTabs.GENERAL,
    );
    const [showPayoutWarning, setShowPayoutWarning] = useState<boolean>(false);
    const history = useHistory<{showPayoutWarning?: boolean}>();

    useEffect(() => {
        const params = new URLSearchParams(history.location.search);
        const tab = params.get('tab');

        if (tab) {
            setActiveTab(tab as SettingsTabs);
        }
    }, [history.location]);

    useEffect(() => {
        if (history.location.state?.showPayoutWarning) {
            setShowPayoutWarning(true);
            history.push({state: {}});
        }
    }, [history]);

    const handleTabChange = (tab: SettingsTabs) => {
        setShowPayoutWarning(false);
        history.push({
            pathname: history.location.pathname,
            search: new URLSearchParams({tab}).toString(),
        });
    };

    return {activeTab, handleTabChange, showPayoutWarning};
};

export default useSettingsPage;
